export default "__VITE_ASSET__El2P6Qgr__"